import ModalViewFactory from './ModalViewFactory'

export default ModalViewFactory
